import * as React from "react";
import { useLocation, useNavigate } from "react-router";
import qs from "query-string";

import { Page } from "_core/components";
import { ErrorTypes, ProductUrls } from "_core/types";
import { OopsPageContent } from "./Oops";
import { AlreadySubmittedPageContent } from "./AlreadySubmittedPageContent";
import { AlreadyVerifiedPageContent } from "./AlreadyVerifiedPageContent";
import { LinkExpiredPageContent } from "./LinkExpiredPageContent";
import { LeadDeletedPageContent } from "./LeadDeletedPageContent";
import { isEmpty } from "lodash";
import { SorryThereWasProblem } from "./SorryThereWasProblem";
import { WeCantFindOrder } from "./WeCantFindOrder";
import { MaintenancePageContent } from "./MaintenancePageContent";

const contentByErrorType = {
  [ErrorTypes.ALREADY_SUBMITTED]: <AlreadySubmittedPageContent />,
  [ErrorTypes.ALREADY_VERIFIED]: <AlreadyVerifiedPageContent />,
  [ErrorTypes.EXPIRED]: <LinkExpiredPageContent />,
  [ErrorTypes.LEAD_DELETED]: <LeadDeletedPageContent />,
  [ErrorTypes.OOPS]: <OopsPageContent />,
  [ErrorTypes.MAINTENANCE]: <MaintenancePageContent />,
  [ErrorTypes.SORRY_THERE_WAS_A_PROBLEM]: <SorryThereWasProblem />,
  [ErrorTypes.WE_CANT_FIND_ORDER]: <WeCantFindOrder />,
};

export const ErrorPage = () => {
  const navigate = useNavigate();
  const {
    state: { error },
  } = useLocation();
  const params = qs.parse(window.location.search);

  const type = !isEmpty(error)
    ? (error as keyof typeof contentByErrorType)
    : (params.type as keyof typeof contentByErrorType);

  const content = contentByErrorType[type];

  React.useEffect(() => {
    if (!content) {
      navigate(ProductUrls.Postcode, { replace: true });
    }
  }, [content, navigate]);

  return (
    <Page title="" subtitle="" url={ProductUrls.ErrorPage}>
      {content}
    </Page>
  );
};
